import { ConnectorType } from '../types/diagram.types';

export interface ConnectorStyle {
  color: string;
  strokeWidth: number;
  strokeDasharray?: string;
  animated: boolean;
  label: string;
  description: string;
  markerEnd: string;
}

export const CONNECTOR_STYLES: Record<ConnectorType, ConnectorStyle> = {
  REST: {
    color: '#1976D2',
    strokeWidth: 2,
    animated: false,
    label: 'REST',
    description: 'HTTP REST API call',
    markerEnd: 'arrowclosed',
  },
  WebSocket: {
    color: '#388E3C',
    strokeWidth: 2,
    strokeDasharray: '8 3',
    animated: true,
    label: 'WS',
    description: 'WebSocket connection',
    markerEnd: 'arrowclosed',
  },
  Kafka: {
    color: '#F57C00',
    strokeWidth: 2,
    strokeDasharray: '6 4',
    animated: true,
    label: 'Event',
    description: 'Kafka/async event',
    markerEnd: 'arrow',
  },
  PostgreSQL: {
    color: '#303F9F',
    strokeWidth: 2,
    animated: false,
    label: 'PG',
    description: 'PostgreSQL query',
    markerEnd: 'arrowclosed',
  },
  Redis: {
    color: '#D32F2F',
    strokeWidth: 2,
    animated: false,
    label: 'Redis',
    description: 'Redis operation',
    markerEnd: 'arrowclosed',
  },
  TimescaleDB: {
    color: '#00796B',
    strokeWidth: 2,
    animated: false,
    label: 'TSDB',
    description: 'TimescaleDB query',
    markerEnd: 'arrowclosed',
  },
  S3: {
    color: '#F9A825',
    strokeWidth: 2,
    strokeDasharray: '4 4',
    animated: false,
    label: 'S3',
    description: 'S3 object storage',
    markerEnd: 'arrowclosed',
  },
  gRPC: {
    color: '#7B1FA2',
    strokeWidth: 2,
    strokeDasharray: '10 3 2 3',
    animated: false,
    label: 'gRPC',
    description: 'gRPC call',
    markerEnd: 'arrowclosed',
  },
};
